<div mat-dialog-title class="dialog-title">
    <button mat-icon-button class="close-button" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
<mat-dialog-content class="mat-typography">
    <ng2-pdfjs-viewer #pdfViewerAutoLoad [pdfSrc]="data.pdfSource" viewerId="MyUniqueID" spread="ODD" zoom="page-fit" (onDocumentLoad)="onLoad($event)"></ng2-pdfjs-viewer>
    <!-- <pdf-viewer [src]="data" [show-all]="true" [original-size]="true" [autoresize]="true" [show-borders]="true" [page]="2" [stick-to-page]="true"></pdf-viewer> -->
</mat-dialog-content>